import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ActivityCode from '@/views/marketing/marketingManage/activityCode/index.vue'


const __default__ = { name: 'DcCosFbuActivityCode' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const permission = {
  add: 'fbu_activity_add_btn',
  edit: 'fbu_activity_edit_btn',
  delete: 'fbu_activity_del_btn',
  enable: 'fbu_activity_enable_btn',
  disable: 'fbu_activity_disable_btn',
  qrcode: 'fbu_activity_qrcode_btn',
  card: 'fbu_activity_card_btn'
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ActivityCode, {
    permission: permission,
    subdomain: "fbu",
    paramCode: "zbu_source_channel_fbu"
  }))
}
}

})